import React, { useEffect, useState } from "react";
import classes from "./Schedule.module.css";
import { Container, Row, Col } from "react-bootstrap";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import Fonts from "../../../stories/assets/Fonts";
import { Button } from "../../../stories/Button/Button";
import { ButtonGroup } from "../../../stories/ButtonGroup/ButtonGroup";
import { DropDown } from "../../../stories/DropDown/DropDown";
import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import CustomFullCalendar from "../../../stories/CustomFullCalendar/index";
import Colors from "../../../stories/assets/Colors";
import {
  ChatOutLineWithDots,
  coachDemoImg,
  ChatFilled,
  ChatOutlined,
  HomeFilled,
  Homeoutlined,
  InsightsFilled,
  InsightsOutlined,
  NotificationFilled,
  Notificationoutlined,
  ReviewFilled,
  ReviewOutlined,
  ScheduleFilled,
  ScheduleOutlined,
  ShortLogo,
  CalendarIconGray,
  ListIconGray,
  CalendarIconBlue,
  ListIconBlue,
} from "../../../constant/imagePath";
import { SideBarMenu } from "../../../stories/SideBarMenu/SideBarMenu";
import { DashboardSidebarWithCalendar } from "../../../stories/DashboardSidebarWithCalendar/DashboardSidebarWithCalendar";
import { useHistory } from "react-router-dom";
import { CoachTodoLessonCard } from "../../../stories/CoachTodoLessonCard/CoachTodoLessonCard";
import ScheduleMobile from "./ScheduleMobile";
import moment from "moment";

const lessonRequests = [
  {
    id: "sch-1",
    userData: {
      displayName: "Tyler",
      profile: coachDemoImg,
    },
    startTime: moment(moment().add(-3, "hours").format())
      .add(0, "days")
      .format(),
    endTime: moment(moment().add(3, "hours").format()).add(0, "days").format(),
    eventDate: moment().add(0, "days").format(),
    type: "1-on-1",
    title: "Tennis Lesson",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    price: 64,
    status: "upcoming",
    timeLeft: "14 hrs",
  },
  {
    id: "sch-2",
    userData: {
      displayName: "Kate",
      profile: coachDemoImg,
    },
    startTime: moment(moment().add(4, "hours").format())
      .add(0, "days")
      .format(),
    endTime: moment(moment().add(5, "hours").format()).add(0, "days").format(),
    eventDate: moment().add(0, "days").format(),
    type: "1-on-1",
    title: "Tennis Lesson",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    price: 64,
    status: "accepted",
    timeLeft: "14 hrs",
  },
  {
    id: "sch-3",
    userData: {
      displayName: "Tyler",
      profile: coachDemoImg,
    },
    startTime: moment(moment().add(6, "hours").format())
      .add(0, "days")
      .format(),
    endTime: moment(moment().add(8, "hours").format()).add(0, "days").format(),
    eventDate: moment().add(0, "days").format(),
    type: "1-on-1",
    title: "Tennis Lesson",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    price: 64,
    status: "evaluate",
    timeLeft: "14 hrs",
  },
  // {
  //   id: "sch-4",
  //   userData: {
  //     displayName: "Tyler",
  //     profile: coachDemoImg,
  //   },
  //   startTime: moment(moment().add(6, "hours").format())
  //     .add(0, "days")
  //     .format(),
  //   endTime: moment(moment().add(8, "hours").format()).add(0, "days").format(),
  //   eventDate: moment().add(0, "days").format(),
  //   type: "1-on-1",
  //   title: "Tennis Lesson",
  //   location: "DeWitt Clinton Park, W 54th St, New York, NY",
  //   price: 64,
  //   status: "evaluate",
  //   timeLeft: "14 hrs",
  // },
];

const ScheduleDesktop = ({ lessionData = [] }) => {
  const history = useHistory();
  const sidebarMenus = [
    {
      icon: Homeoutlined,
      hoverIcon: HomeFilled,
      text: "Todo",
      onClick: () => history.push("/todo"),
      activeText: "todo",
    },
    {
      icon: Notificationoutlined,
      hoverIcon: NotificationFilled,
      text: "Notifications",
      onClick: () => history.push("/notifications"),
      activeText: "notifications",
    },
    {
      icon: ScheduleOutlined,
      hoverIcon: ScheduleFilled,
      text: "Schedule",
      onClick: () => history.push("/schedule"),
      activeText: "schedule",
    },
    {
      icon: ChatOutlined,
      hoverIcon: ChatFilled,
      text: "Chat",
      onClick: () => history.push("/chat"),
      activeText: "chat",
    },
    {
      icon: ReviewOutlined,
      hoverIcon: ReviewFilled,
      text: "Reviews",
      onClick: () => history.push("/reviews"),
      activeText: "reviews",
    },
    {
      icon: InsightsOutlined,
      hoverIcon: InsightsFilled,
      text: "Insights",
      onClick: () => history.push("/insights"),
      activeText: "insights",
    },
  ];
  const [menuItem, setMenuItem] = useState("schedule");
  const [locations, setLocations] = useState();
  const [isView, setIsView] = useState("calendar");
  const [searchText, setSearchText] = useState("");
  const [searchType, setSearchType] = useState();

  return (
    <div className={[classes.ScheduleScreen].join(" ")}>
      <SideBarMenu
        logo={ShortLogo}
        items={sidebarMenus}
        state={menuItem}
        customStyle={{ minHeight: "100vh", height: "auto" }}
      />
      <Container fluid className={[classes.container].join(" ")}>
        <Row className={["g-0", classes.row].join(" ")}>
          <Col md={4} xl={3}>
            <DashboardSidebarWithCalendar
              totalHeading1="Total earnings"
              totalHeading2="Total bookings"
              totalValue1={`$${567}`}
              totalValue2={14}
              locations={locations}
              setLocations={setLocations}
              isShowHeader={true}
            />
          </Col>
          <Col
            md={8}
            xl={9}
            className={[classes.p24, classes.mainContent].join(" ")}
          >
            <div className={[classes.mb32].join(" ")}>
              <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
                Schedule
              </h3>
            </div>

            <Row className={[classes.mb24].join(" ")}>
              <Col md={4} xl={5}>
                <InputWithSearchIcon
                  placeholder="Search"
                  state={searchText}
                  setter={setSearchText}
                />
              </Col>
              <Col md={3} xl={3}>
                <DropDown
                  placeholder="Show"
                  options={[{ label: "All", value: "All" }]}
                  state={searchType}
                  setter={setSearchType}
                />
              </Col>
              <Col md={5} xl={4} className={[classes.headerBtnCol].join(" ")}>
                <div>
                  <ButtonGroup
                    customStyle={{
                      backgroundColor: Colors.white,
                      padding: "2px",
                      justifyContent: "center",
                    }}
                    btnIcon1={
                      isView === "calendar"
                        ? CalendarIconBlue
                        : CalendarIconGray
                    }
                    btnIcon2={isView === "list" ? ListIconBlue : ListIconGray}
                    onClick1={() => setIsView("calendar")}
                    onClick2={() => setIsView("list")}
                  />
                </div>
                <div className={[classes.avialibilityBtnDiv].join(" ")}>
                  <Button
                    label="Set availability"
                    primary={true}
                    customStyle={{ width: "100%" }}
                  />
                </div>
              </Col>
            </Row>

            {isView === "calendar" && (
              <CustomFullCalendar ScheduleData={lessionData} />
            )}

            {isView === "list" && (
              <>
                {lessionData?.map((item) => {
                  return <CoachTodoLessonCard data={item} />;
                })}
              </>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

const Schedule = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);

  return isMobile ? (
    <ScheduleMobile lessionData={lessonRequests} />
  ) : (
    <ScheduleDesktop lessionData={lessonRequests} />
  );
};

export default Schedule;
